<section #spacer class="eco-virtual-spacer" [style.height.px]="totalSize">
  <ng-container *ngFor="let vi of virtualItems; trackBy: trackVirtual">
    <section
      class="eco-virtual-item"
      [style.transform]="'translateY(' + (vi.start - scrollMargin) + 'px)'"
    >
      <section
        [ecoMeasure]="virtualizer"
        [attr.data-index]="vi.index"
        class="eco-virtual-measure-wrapper"
      >
        <ng-container
          *ngTemplateOutlet="
            itemTemplate;
            context: {
              $implicit: items[vi.index],
              index: vi.index,
              last: vi.index === items.length - 1
            }
          "
        ></ng-container>
      </section>
    </section>
  </ng-container>
</section>
